import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MeusContatosEditPageRoutingModule } from './meus-contatos-edit-routing.module';

import { MeusContatosEditPage } from './meus-contatos-edit.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MeusContatosEditPageRoutingModule
  ],
  declarations: [MeusContatosEditPage]
})
export class MeusContatosEditPageModule {}
